import { SenecCard, useScreenSize } from "src/newsenec-ui-components";
import { Box, CardContent, CardMedia, Stack, Typography } from "@mui/material";
import { ReactElement } from "react";

export interface ImgData {
    title: string;
    description: string;
    url: string;
}

export interface CardInfo {
    title: string;
    description: string;
    image?: ImgData;
    message?: ReactElement | string;
}

export interface InfoCardProps {
    cardInfo: CardInfo;
    "data-testid"?: string;
}

export const SenecInfoCard = ({ cardInfo, "data-testid": dataTestId = "info-card" }: InfoCardProps) => {
    const { isMobile } = useScreenSize();

    if (cardInfo.message === undefined) return <></>;

    return (
        <SenecCard
            data-testid={dataTestId}
            sx={{
                display: "flex",
                flexDirection: isMobile ? "column-reverse" : "row",
                alignItems: "top",
                padding: 0,
            }}
        >
            <CardContent sx={{ padding: 3, width: "100%" }}>
                <Stack flexDirection="column" spacing={3}>
                    {/* title */}
                    <Typography variant="h4" data-testid={`${dataTestId}-title`}>
                        {cardInfo.title}
                    </Typography>
                    {/* description */}
                    <Typography data-testid={"card-description"}>{cardInfo.description}</Typography>
                    {/* message */}
                    {cardInfo.message ? (
                        typeof cardInfo.message === "string" ? (
                            <Typography data-testid="message">{cardInfo.message}</Typography>
                        ) : (
                            <Box data-testid="message" sx={{ display: "grid" }}>
                                {cardInfo.message}
                            </Box>
                        )
                    ) : (
                        <></>
                    )}
                </Stack>
            </CardContent>
            {cardInfo.image && (
                <CardMedia
                    component="img"
                    height={"auto"}
                    sx={{ maxWidth: isMobile ? "auto" : "400px" }}
                    alt={cardInfo.image.description}
                    image={cardInfo.image.url}
                    title={cardInfo.image.title}
                    data-testid="card-image"
                />
            )}
        </SenecCard>
    );
};
